import { render } from "./trending.vue?vue&type=template&id=5acefa66"
import script from "./trending.vue?vue&type=script&lang=js"
export * from "./trending.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__